import React, { useMemo } from 'react';
import { Box, FlexControlledForm, Text } from '@common-fe/common-fe';

import useMetricsFields from './hooks/useMetricsFields';
import useStore from './stores/useMetrics.store';

interface Props {
  isShowErrors?: boolean;
  isEditMode?: boolean;
  isDisabled?: boolean;
  onDirty?: (isDirty: boolean) => void;
}

const Metrics: React.FC<Props> = ({ isEditMode, isShowErrors, onDirty }) => {
  const fields = useMetricsFields({ isEditMode });
  const sourceState = useStore((state) => state.sourceState);
  const handleSetState = useStore((state) => state.setState);

  const key = useMemo(() => {
    return `${sourceState?.substantiationRate}`;
  }, [sourceState?.substantiationRate]);

  return (
    <Box background="canvas" key={key} round="container1Round">
      <FlexControlledForm
        isResetSubfieldsDisabled
        subTitle={
          <Box direction="column" margin={{ bottom: 'spacing16' }}>
            <Text size="xlarge" color="textTitle">
              Metrics
            </Text>
          </Box>
        }
        testId="metrics"
        fields={fields}
        showError={isShowErrors}
        editMode={isEditMode}
        onChangeValues={handleSetState}
        onDirty={onDirty}
        isThinMode
      />
    </Box>
  );
};

export default Metrics;
